/* import __COLOCATED_TEMPLATE__ from './filter-block-options.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable @intercom/intercom/no-component-inheritance */
/* eslint-disable ember/no-side-effects */
import { copy } from 'ember-copy';
import { computed } from '@ember/object';
import BaseFilterBlockPopover from 'predicates/components/filter-block/base-filter-block-popover';
export default BaseFilterBlockPopover.extend({
  classNames: ['filter-block__options', 'flex-auto', 'flex', 'flex-col'],
  classNameBindings: ['componentAttrs.isOneLine:o__one-line', 'componentAttrs.isWide:o__wide'],
  attributeBindings: ['data-test-filter-block-options'],
  'data-test-filter-block-options': true,
  predicate: computed('componentAttrs.predicate', 'localPredicate', {
    get() {
      let localPredicate = this.localPredicate;
      if (localPredicate === undefined) {
        localPredicate = copy(this.get('componentAttrs.predicate'), true);
        this.set('localPredicate', localPredicate);
      }
      return localPredicate;
    },
    set(key, value) {
      this.set('localPredicate', value);
    }
  }),
  actions: {
    changePredicateComparison(comparison) {
      this.predicate.changeComparison(comparison);
      this.get('componentAttrs.onUpdate')(this.predicate.serialize());
    },
    changePredicateValue(value) {
      this.predicate.changeValue(value);
      this.get('componentAttrs.onUpdate')(this.predicate.serialize());
    }
  }
});